// components/admin/ImageSlotsPicker.jsx
import React, { useMemo, useRef } from 'react';
import { API_BASE_URL } from "../../utils/constants";

export default function ImageSlotsPicker({
  existingImages = [],
  pendingFiles = [],
  onPick,
  onRemovePending,
  onRemoveExisting,
  uploadsBase = '/uploads', // fallback if you don't pass API_BASE_URL here
}) {
  const inputRef = useRef(null);
  const total = existingImages.length + pendingFiles.length;
  const remainingSlots = Math.max(0, 5 - total);

  const pendingPreviews = useMemo(
    () => pendingFiles.map((f) => ({ url: URL.createObjectURL(f), file: f })),
    [pendingFiles]
  );

  const triggerPick = () => inputRef.current?.click();
  const handleChange = (e) => {
    const file = e.target.files?.[0];
    if (file) onPick(file);
    e.target.value = '';
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {/* Existing images */}
      {existingImages.slice(0, 5).map((img, idx) => {
        return (
          <div key={`ex-${img.id || idx}`} className="relative w-10 h-10">
            <img src={`${API_BASE_URL}/uploads/${img.filename}`} alt="img" className="w-10 h-10 object-cover rounded" />
            <button
              type="button"
              className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-black text-white text-[10px] leading-4 text-center"
              onClick={() => onRemoveExisting(img)}
              title="Remove"
            >
              ×
            </button>
          </div>
        );
      })}

      {/* Pending previews */}
      {pendingPreviews.map((pp, idx) => (
        <div key={`pp-${idx}`} className="relative w-10 h-10">
          <img src={pp.url} alt="pending" className="w-10 h-10 object-cover rounded" />
          <button
            type="button"
            className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-black text-white text-[10px] leading-4 text-center"
            onClick={() => onRemovePending(idx)}
            title="Remove"
          >
            ×
          </button>
        </div>
      ))}

      {/* Empty slots */}
      {Array.from({ length: remainingSlots }).map((_, i) => (
        <button
          key={`slot-${i}`}
          type="button"
          onClick={triggerPick}
          className="w-10 h-10 rounded border border-dashed grid place-items-center text-[10px] text-gray-500"
          title="Add image"
        >
          +
        </button>
      ))}

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={handleChange}
      />
    </div>
  );
}
